// Per-line palette — mirrors backend services.py LINE_COLORS so the sacred
// print, the reading text, and the keepsake all share one color language.
export const LINE_COLORS = {
  heart: "#8A2E2E", // maroon
  head: "#2E5A57", // deep teal
  life: "#9C4A24", // terracotta
  fate: "#6E6A2A", // olive
};

export const lineColor = (key) => LINE_COLORS[key] || "#20180E";

// Darker ink variants of each line color — used for body/note text so the
// color-coding reads clearly on the light parchment (better contrast on phones).
export const LINE_INK = {
  heart: "#5E1E1E",
  head: "#1E3E3B",
  life: "#6E3116",
  fate: "#47451B",
};

export const lineInk = (key) => LINE_INK[key] || "#20180E";
